import {AbstractService} from 'services/AbstractService';


const CURRENCY_RATE_CREATE_URL = 'api/connections/{0}/currency/rates';


export class CurrencyService extends AbstractService{
  add (connectionId, accountId, internalCurrencyId, externalCurrencyId, date, rate) {
    return this.client.post(
      CURRENCY_RATE_CREATE_URL.format(connectionId),
      {
        connection_id: connectionId,
        internal_currency_id: internalCurrencyId,
        external_currency_id: externalCurrencyId,
        date,
        rate
      },
      {accountId}
    );
  }
}
